import { Box, HStack, Textarea, FormControl, Text, Input, FormLabel, Select, InputGroup, Button, Flex, FormErrorMessage, useToast, InputLeftElement, Checkbox, Table, Tbody, Td, Th, Thead, Tr, Portal, useDisclosure } from '@chakra-ui/react';
import { useFormik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { Complementary, GetComplementary, IEducation, IGetworkexperience, ProQualifications, Speciality } from '../../models/trainer-registration.model';
import trainerRegistration from '../../services/trainer/trainerRegistration';
import Loading from '../common/Loading';
import { ComplementaryExperienceModal } from './modals/ComplementaryExperienceModal';
import { EduQualificationModal } from './modals/EduQualificationModal';
import { ProfessionalCertModal } from './modals/ProfessionalCertModal';
import { SpecialtyAreaModal } from './modals/SpecialtyAreaModal';
import { SpecialtyFieldModal } from './modals/SpecialtyFieldModal';
import { WorkExperienceModal } from './modals/WorkExperienceModal';

const CurriculumVitae = ({ nextPage, prePage }: { nextPage: any, prePage: any }) => {
    const [complementaryX, setComplementaryX] = useState(false);
    const [workXperience, setWorkXperience] = useState(false);
    const [professionalMembership, setProfessionalMembership] = useState(false);
    const [educationQualification, setEducationQualification] = useState(false);
    const [fieldSpeciality, setFieldSpeciality] = useState(false);
    const [areaSpeciality, setAreaSpeciality] = useState(false);
    const [getcomplementaryX, setGetComplementaryX] = useState<GetComplementary[]>([]);
    const [getworkXperience, setGetWorkXperience] = useState<IGetworkexperience[]>([]);
    const [getprofessionalMembership, setGetProfessionalMembership] = useState<ProQualifications[]>([]);
    const [geteducationQualification, setGetEducationQualification] = useState<IEducation[]>([]);
    const [getfieldSpeciality, setGetFieldSpeciality] = useState<Speciality[]>([]);
    const [getareaSpeciality, setGetAreaSpeciality] = useState<any[]>([]);

    const { isOpen, onOpen, onClose } = useDisclosure();
    const mountedRef = useRef(true)
    const courseFormatRef = useRef<HTMLSelectElement>(null)
    const [gender, setGender] = useState<any[]>([]);
    const [reload, setReload] = useState(false)
    const [loading, setLoading] = useState(true)
    const toast = useToast();
    useEffect(() => {
        trainerRegistration
            .getUserEducation()
            .then((response) => {
                setGetEducationQualification(response.data)
                setLoading(false)
                
            })
            .catch((err) => err);
        trainerRegistration
            .getUserExperience()
            .then((response) => {
                setGetWorkXperience(response.data)
                setLoading(false)
                
            })
            .catch((err) => err);

        trainerRegistration
            .getUserQualifications()
            .then((response) => {
                setGetProfessionalMembership(response.data)
                setLoading(false)
                
            })
            .catch((err) => err);

        trainerRegistration
            .getUserSpecialty()
            .then((response) => {
                
                const specialities = response.data.specialities
                const areaSpeciality: Speciality[] = [];
                const fieldSpeciality: Speciality[] = []
                specialities.forEach((speciality) => {
                    speciality.type == 'Area' ? areaSpeciality.push(speciality) : fieldSpeciality.push(speciality)
                })
                setGetAreaSpeciality(areaSpeciality);
                setGetFieldSpeciality(fieldSpeciality);
                setLoading(false)
            })
            .catch((err) => err);

        trainerRegistration
            .getUserComplimentaryExperience()
            .then((response) => {
                setGetComplementaryX(response.data)
                
                setLoading(false)
            })
            .catch((err) => err);


    }, [reload]);

    const updateFieldSpeciality = () => {
        trainerRegistration
            .getUserSpecialty()
            .then((response) => {
                // setGetFieldSpeciality(response.data)
                
            })
            .catch((err) => err);
    }
    const updateAreaSpeciality = () => {
        trainerRegistration
            .getUserSpecialty()
            .then((response) => {
                // setGetFieldSpeciality(response.data)
                
            })
            .catch((err) => err);
    }

    const openComplementaryXperience = async () => {
        setComplementaryX(true);
        setWorkXperience(false);
        setProfessionalMembership(false);
        setEducationQualification(false);
        setFieldSpeciality(false)
        setAreaSpeciality(false);

        onOpen();
    };
    const openWorkXperience = async () => {
        setComplementaryX(false);
        setWorkXperience(true);
        setProfessionalMembership(false);
        setEducationQualification(false);
        setFieldSpeciality(false);
        setAreaSpeciality(false)

        onOpen();
    };
    const openProfessionalMembersip = async () => {
        setComplementaryX(false);
        setWorkXperience(false);
        setProfessionalMembership(true);
        setEducationQualification(false);
        setFieldSpeciality(false);
        setAreaSpeciality(false)

        onOpen();
    };
    const openEducationQualification = async () => {
        setComplementaryX(false);
        setWorkXperience(false);
        setProfessionalMembership(false);
        setEducationQualification(true);
        setFieldSpeciality(false);
        setAreaSpeciality(false)

        onOpen();
    };
    const openFieldSpeciality = async () => {
        setComplementaryX(false);
        setWorkXperience(false);
        setProfessionalMembership(false);
        setEducationQualification(false);
        setFieldSpeciality(true);
        setAreaSpeciality(false)

        onOpen();
    };
    const openAreaSpeciality = async () => {
        setComplementaryX(false);
        setWorkXperience(false);
        setProfessionalMembership(false);
        setEducationQualification(false);
        setAreaSpeciality(true);
        setFieldSpeciality(false);

        onOpen();
    };
    const reloadData = () => {
        setReload(!reload)
    }


    return (
        <>
            {
                loading ? <Loading /> :
                    <Box px={6} mb='50px' mx='auto'>
                        <Flex justifyContent='center' mb='35px'>
                            <Text mx='auto' fontSize='32px' fontWeight='800'>Trainer's Profile</Text>
                        </Flex>
                        <Box width='100%' mb='33px'>
                            <Flex justifyContent='space-between'>
                                <Text fontWeight='600' fontSize='14px' color='#616161'>1. Field of Speciality</Text>
                                <Button
                                    colorScheme="red"
                                    variant="outline"

                                    size="sm"
                                    px={6}
                                    fontSize={12}
                                    onClick={() => openFieldSpeciality()}
                                >
                                    Add
                                </Button>

                            </Flex>
                            <Table variant="simple" mt={2} size="sm" >
                                <Thead fontWeight="normal" bg="#FEFEFE">
                                    <Tr color="brand.subtitle">

                                        <Th textTransform="none" fontWeight='600' fontSize='12px' color='#616161' width='50px'>SN</Th>
                                        <Th textTransform="none" fontWeight='600' fontSize='12px' color='#616161'>Field of speciality</Th>

                                    </Tr>
                                </Thead>

                                <Tbody>
                                    {
                                        getfieldSpeciality.map((each, index) => (
                                            <Tr key={index} fontSize="14px" bg="#FEFEFE" >
                                                <Td width='50px'>
                                                    {index + 1}
                                                </Td>

                                                <Td>{each.speciality.name}</Td>

                                            </Tr>
                                        ))
                                    }



                                </Tbody>
                            </Table>

                        </Box>
                        <Box width='100%' mb='33px'>
                            <Flex justifyContent='space-between'>
                                <Text fontWeight='600' fontSize='14px' color='#616161'>2. Area of Speciality</Text>
                                <Button
                                    colorScheme="red"
                                    variant="outline"

                                    size="sm"
                                    px={6}
                                    fontSize={12}
                                    onClick={() => openAreaSpeciality()}
                                >
                                    Add
                                </Button>

                            </Flex>
                            <Table variant="simple" mt={2} size="sm" >
                                <Thead fontWeight="normal" bg="#FEFEFE">
                                    <Tr color="brand.subtitle">

                                        <Th textTransform="none" fontWeight='600' fontSize='12px' color='#616161' width='50px'>SN</Th>
                                        <Th textTransform="none" fontWeight='600' fontSize='12px' color='#616161'>Area of speciality</Th>

                                    </Tr>
                                </Thead>

                                <Tbody>
                                    {
                                        getareaSpeciality.map((each, index) => (
                                            <Tr key={index} fontSize="14px" bg="#FEFEFE" >
                                                <Td width='50px'>
                                                    {index + 1}
                                                </Td>

                                                <Td>{each.speciality.name}</Td>

                                            </Tr>
                                        ))
                                    }

                                </Tbody>
                            </Table>
                           

                        </Box>
                        <Box width='100%' mb='33px'>
                            <Flex justifyContent='space-between'>
                                <Text fontWeight='600' fontSize='14px' color='#616161'>3. Education Qualification</Text>
                                <Button
                                    colorScheme="red"
                                    variant="outline"

                                    size="sm"
                                    px={6}
                                    fontSize={12}
                                    onClick={() => openEducationQualification()}
                                >
                                    Add
                                </Button>

                            </Flex>
                            <Box width='100%' overflowX={{lg:'auto',md:'scroll', sm:'scroll', base:'scroll'}}>
                            <Table variant="simple" mt={2} size="sm" >
                                <Thead fontWeight="normal" bg="#FEFEFE">
                                    <Tr color="brand.subtitle">

                                        <Th textTransform="none" fontWeight='600' fontSize='12px' color='#616161' width='50px'>SN</Th>
                                        <Th textTransform="none" fontWeight='600' fontSize='12px' color='#616161'>Institution</Th>
                                        <Th textTransform="none"></Th>

                                        <Th textTransform="none">Degree</Th>
                                        <Th textTransform="none">Class Of Degree</Th>
                                        <Th textTransform="none">Year Obtained</Th>


                                    </Tr>
                                </Thead>

                                <Tbody>

                                    {
                                        geteducationQualification.map((each, index) => (
                                            <Tr key={index} fontSize="14px" bg="#FEFEFE" >
                                                <Td width='50px'>
                                                    {index + 1}
                                                </Td>

                                                <Td>{each.institution}</Td>
                                                <Td> {each.discipline}</Td>
                                                <Td>{each.degree}</Td>

                                                <Td>{each.class_of_degree}</Td>
                                                <Td>{each.year}</Td>

                                            </Tr>
                                        ))
                                    }


                                </Tbody>
                            </Table>
                            </Box>
                        </Box>
                        <Box width='100%' mb='33px'>
                            <Flex justifyContent='space-between'>
                                <Text fontWeight='600' fontSize='14px' color='#616161'>4. Professional Membership / Qualification</Text>
                                <Button
                                    colorScheme="red"
                                    variant="outline"

                                    size="sm"
                                    px={6}
                                    fontSize={12}
                                    onClick={() => openProfessionalMembersip()}
                                >
                                    Add
                                </Button>

                            </Flex>
                            <Box width='100%' overflowX={{lg:'auto',md:'scroll', sm:'scroll', base:'scroll'}}>
                            <Table variant="simple" mt={2} size="sm" >
                                <Thead fontWeight="normal" bg="#FEFEFE">
                                    <Tr color="brand.subtitle">

                                        <Th textTransform="none" width='50px'>SN</Th>
                                        <Th textTransform="none">Professional Organization</Th>
                                        <Th textTransform="none">Description </Th>
                                        <Th textTransform="none">Start Year </Th>
                                        <Th textTransform="none">Age(years) </Th>

                                    </Tr>
                                </Thead>

                                <Tbody>
                                    {
                                        getprofessionalMembership.map((each, index) => (
                                            <Tr key={index} fontSize="14px" bg="#FEFEFE" >
                                                <Td width='50px'>
                                                    {index + 1}
                                                </Td>

                                                <Td>{each.organization}</Td>
                                                <Td> {each.description}</Td>
                                                <Td>{each.joined}</Td>
                                                <Td>{each.joined}</Td>



                                            </Tr>
                                        ))
                                    }


                                </Tbody>
                            </Table>
                            </Box>

                        </Box>
                        <Box width='100%' mb='33px'>
                            <Flex justifyContent='space-between'>
                                <Text fontWeight='600' fontSize='14px' color='#616161'>5. Employment History</Text>
                                <Button
                                    colorScheme="red"
                                    variant="outline"

                                    size="sm"
                                    px={6}
                                    fontSize={12}
                                    onClick={() => openWorkXperience()}
                                >
                                    Add
                                </Button>

                            </Flex>
                            <Box width='100%' overflowX={{lg:'auto', md:'scroll', sm:'scroll', base:'scroll'}}>
                            <Table variant="simple" mt={2} size="sm" >
                                <Thead fontWeight="normal" bg="#FEFEFE">
                                    <Tr color="brand.subtitle">

                                        <Th textTransform="none" width='50px'>SN</Th>
                                        <Th textTransform="none">Job Title</Th>
                                        <Th textTransform="none">Sector</Th>

                                        <Th textTransform="none">Organisation</Th>
                                        <Th>Organisation Address</Th>
                                        <Th>Brief Description</Th>



                                    </Tr>
                                </Thead>

                                <Tbody>


                                    {
                                        getworkXperience.map((each, index) => (
                                            <Tr key={index} fontSize="14px" bg="#FEFEFE" >
                                                <Td width='50px'>
                                                    {index + 1}
                                                </Td>

                                                <Td>{each.title}</Td>
                                                <Td> {each.sector}</Td>
                                                <Td>{each.organization_name}</Td>
                                                <Td>{each.organization_address}</Td>
                                                <Td>{each.description}</Td>



                                            </Tr>
                                        ))
                                    }


                                </Tbody>
                            </Table>
                            </Box>
                        </Box>
                        <Box width='100%' mb='33px'>
                            <Flex justifyContent='space-between'>
                                <Text fontWeight='600' fontSize='14px' color='#616161'>6. Complementary Experience</Text>
                                <Button
                                    colorScheme="red"
                                    variant="outline"

                                    size="sm"
                                    px={6}
                                    fontSize={12}
                                    onClick={() => openComplementaryXperience()}
                                >
                                    Add
                                </Button>

                            </Flex>
                            <Box width='100%' overflowX={{lg:'auto',md:'scroll', sm:'scroll', base:'scroll'}}>
                            <Table variant="simple" mt={2} size="sm" >
                                <Thead fontWeight="normal" bg="#FEFEFE">
                                    <Tr color="brand.subtitle">

                                        <Th textTransform="none" width='50px'>SN</Th>
                                        <Th textTransform="none" width='30%'>Experience Criteria</Th>
                                        <Th width='30%'>Remark</Th>
                                        <Th width='30%'>Years of Experience</Th>
                                    </Tr>
                                </Thead>

                                <Tbody>

                                    {
                                        getcomplementaryX.map((each, index) => (
                                            <Tr key={index} fontSize="14px" bg="#FEFEFE" >
                                                <Td width='50px'>
                                                    {index + 1}
                                                </Td>

                                                <Td>{each.complementary_id}</Td>
                                                <Td> {each.remark}</Td>
                                                <Td>{each.years_of_experience}</Td>



                                            </Tr>
                                        ))
                                    }
                                </Tbody>
                            </Table>
                            </Box>

                        </Box>
                        {complementaryX && (
                            <Portal>
                                <ComplementaryExperienceModal
                                    isOpenComplementaryX={isOpen}
                                    onClosecomplementaryX={onClose}
                                    isComplementary={complementaryX}
                                    reload={reloadData}
                                />
                            </Portal>
                        )}
                        {workXperience && (
                            <Portal>
                                {" "}
                                <WorkExperienceModal
                                    isOpenworkXperience={isOpen}
                                    onCloseWorkXperience={onClose}
                                    isWorkXperience={workXperience}
                                    reload={reloadData}
                                />{" "}
                            </Portal>
                        )}
                        {professionalMembership && (
                            <Portal>
                                {" "}
                                <ProfessionalCertModal
                                    isOpenProfessionalMembership={isOpen}
                                    onCloseProfessionalMembership={onClose}
                                    isProfessionalMembership={professionalMembership}
                                    reload={reloadData}
                                /> {" "}
                            </Portal>
                        )}
                        {educationQualification && (
                            <Portal>
                                {" "}
                                <EduQualificationModal
                                    isOpenEducationQualification={isOpen}
                                    onCloseEducationQualification={onClose}
                                    isEducationQualification={educationQualification}
                                    reload={reloadData}
                                />{" "}
                            </Portal>
                        )}
                        {fieldSpeciality && (
                            <Portal> {" "}
                                <SpecialtyFieldModal
                                    isOpenFieldSpeciality={isOpen}
                                    onCloseFieldSpeciality={onClose}
                                    isFieldSpeciality={fieldSpeciality}
                                    updateFieldSpeciality={updateFieldSpeciality}
                                    reload={reloadData}
                                /> {" "}
                            </Portal>
                        )}
                        {areaSpeciality && (
                            <Portal> {" "}
                                <SpecialtyAreaModal
                                    isOpenAreaSpeciality={isOpen}
                                    onCloseAreaSpeciality={onClose}
                                    isAreaSpeciality={areaSpeciality}
                                    updateAreaSpeciality={updateAreaSpeciality}
                                    reload={reloadData}
                                /> {" "}
                            </Portal>
                        )}


                    </Box>
            }
        </>

    );
}

export default CurriculumVitae;